import { render, staticRenderFns } from "./CareimageMultipleRegister.vue?vue&type=template&id=3a20fede&scoped=true&lang=pug"
import script from "./CareimageMultipleRegister.vue?vue&type=script&lang=ts"
export * from "./CareimageMultipleRegister.vue?vue&type=script&lang=ts"
import style0 from "./CareimageMultipleRegister.vue?vue&type=style&index=0&id=3a20fede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20fede",
  null
  
)

export default component.exports